export default __webpack_public_path__ + "static/media/fluent-slide-search.e8981475.svg";